import {
  createQueryKeyFactory,
  type QueryKeyPart,
} from "@circle-react/lib/queries/createQueryKeyFactory";

export const queryKeyRoot = createQueryKeyFactory("post");

export const listKeyRoot = (...parts: QueryKeyPart[]) =>
  queryKeyRoot.key("list", ...parts);

export const detailKeyRoot = (...parts: QueryKeyPart[]) =>
  queryKeyRoot.key("detail", ...parts);

export const postQueryKeys = {
  list: listKeyRoot(),
  feed: listKeyRoot("feed"),
  detail: detailKeyRoot(),
};
